import {Injectable} from "@angular/core";
import {CartDetail} from "@app/core/cart/domain/dtos/cart-detail";
import {CartLine} from "@app/core/cart/domain/dtos/cart-line";
import {CartQuantityNotifier} from "@app/core/cart/domain/cart-quantity-notifier";
import {CartLineRepository} from "./cart-line-repository.service";
import {combineLatest, Observable} from "rxjs";
import {map, switchMap} from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class GetCartDetailUseCase {
    constructor(
        private cartLineRepository: CartLineRepository,
        private cartQuantityNotifier: CartQuantityNotifier
    ) {
    }

    cartLines$: Observable<CartLine[]> = this.cartQuantityNotifier.cartQuantity$.pipe(
        switchMap(() => this.cartLineRepository.getCartLines())
    );

    execute(): Observable<CartDetail> {
        return combineLatest([
            this.cartLines$
        ]).pipe(
            // Create a CartDetail from the list of CartLines
            map(([cartLines]) => ({
                lines: cartLines,
                totalPrice: cartLines
                    .map(cartLine => cartLine.price * cartLine.quantity)
                    .reduce((previous, current) => previous + current, 0),
                palletsPrice: cartLines
                    .map(cartLine => (cartLine.palletPrice ?? 0) * cartLine.quantity)
                    .reduce((previous, current) => previous + current, 0)
            }))
        )
    }

}
